export default __webpack_public_path__ + "static/media/cc41f0619ce4438cd1399bdfdc6a797b1600257265465.1fbefda2.webp";